module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABKYAAAEcAQMAAADHuS4RAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAGUExURUdwTAAVKnMkq5MAAAABdFJOUwBA5thmAAAAxUlEQVR42u3TQQkAAAgAMftnFjSFqLBLsM9FHSyDioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKiuqvSprIg1RUq6oGeupbPzb2/loAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/scenes/LandingPage/images/bg.png
// module id = 960
// module chunks = 0